import m from "./ghl-ui.es1506.js";
import v from "./ghl-ui.es1466.js";
import s from "./ghl-ui.es1505.js";
function y(t, a) {
  v(2, arguments);
  var r = s(a);
  r % 7 === 0 && (r = r - 7);
  var o = 1, e = m(t), n = e.getUTCDay(), d = r % 7, f = (d + 7) % 7, i = (f < o ? 7 : 0) + r - n;
  return e.setUTCDate(e.getUTCDate() + i), e;
}
export {
  y as default
};
